import React from 'react';

const LedgerStatementTableHeader = () => {
  return (
    <>
      <tr>
        <th className='align-middle' rowSpan={2}>Date</th>
        <th className='align-middle' rowSpan={2}>Ledger Name</th>
        <th className='align-middle' rowSpan={2}>Narration</th>
        <th className='align-middle' rowSpan={2}>Document Number</th>
        <th rowSpan={1} colSpan={2}>Amount</th>
        <th className='align-middle' rowSpan={2}>Balance</th>
        <th className='align-middle' rowSpan={2}>Category</th>
        <th rowSpan={2}></th>
      </tr>
      <tr>
        <th>Debit</th>
        <th>Credit</th>
      </tr>
    </>
  )
};

export default LedgerStatementTableHeader;